export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const DISTRIBUTOR_CONTRACT_DATA = 'DISTRIBUTOR_CONTRACT_DATA';
export const MANAGE_CLAIMS_DATA = 'MANAGE_CLAIMS_DATA';
export const MANAGE_CLAIMS_PROFILE = 'MANAGE_CLAIMS_PROFILE';
export const MANAGE_CLAIMS_NEXT_STATUS = 'MANAGE_CLAIMS_NEXT_STATUS';
export const MANAGE_CLAIMS_USER_TABS = 'MANAGE_CLAIMS_USER_TABS';
